import React from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { MultiSectionDigitalClock } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

interface TimePickerModalProps {
  open: boolean;
  onClose: () => void;
  value: string | null;
  onChange: (newTime: string) => void;
}

export const TimePickerModal: React.FC<TimePickerModalProps> = ({
  open,
  onClose,
  value,
  onChange,
}) => {
  const { t, i18n } = useTranslation();

  const handleTimeChange = (newTime: moment.Moment | null) => {
    if (newTime) {
      onChange(newTime.format('HH:mm'));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: '16px',
          padding: '16px',
        },
      }}
    >
      <DialogContent>
        <MultiSectionDigitalClock
          value={value ? moment(value, 'HH:mm') : null}
          onChange={handleTimeChange}
          autoFocus
          ampm={i18n.language === 'en-US'}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            borderRadius: '100px',
            textTransform: 'none',
            padding: '8px 24px',
          }}
        >
          {t('OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
